import React from 'react'
import { CloseButton, Form } from 'react-bootstrap'
import styled from 'styled-components'
import { colors } from '../../styles/colors'
import { useWithdrawalsState } from '../../stores/WithdrawalsProvider'
import { useTranslation } from 'react-i18next'
import { formatedDate } from '../../utils/formatedDate'
import { PickingIcon1, PickingIcon2, PickingIcon3, PickingIcon4, PickingIcon5, PickingIcon6, PickingIcon7 } from './PickingProcessFilter'

const StyledWrapper = styled.div`
  //display: flex;
  flex-grow: 1;
  padding: 4px;

  .form-label {
    margin-bottom: 5px;
  }
`

const StyledItem = styled.div`
  margin: 5px;
  padding: 6px 10px;
  border: 1px solid ${colors.borderColor};
  border-radius: 8px;

  .close {
    margin-left: 15px;
  }
`

const StyledItemWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -5px;
`
const ActiveTableFilters = () => {
  const {
    orderProcessTypeFilter, setOrderProcessTypeFilter,
    storehouseFilter, setStorehouseFilter,
    startDateFilter, setStartDateFilter,
    endDateFilter, setEndDateFilter,
    officeName, officeFilter, setOfficeFilter,
    costCenterName, costCenterFilter, setCostCenterFilter,
    pickingProcessFilter, setPickingProcessFilter,
  } = useWithdrawalsState()

  const { t } = useTranslation()
  const formatedStartDate = () => {
    if (!!startDateFilter) {
      if (formatedDate(startDateFilter)) return formatedDate(startDateFilter)
    }
    return "";
  }
  const formatedEndDate = () => {
    if (!!endDateFilter) {
      if (formatedDate(endDateFilter)) return formatedDate(endDateFilter)
    }
    return "";
  }
  const startDate = formatedStartDate();
  const endDate = formatedEndDate();
  if (!officeFilter && !costCenterFilter && !storehouseFilter && !startDate && !endDate && !orderProcessTypeFilter && !pickingProcessFilter) {
    return null
  }
  return (
    <StyledWrapper>
      <Form.Label>{t('employeesPage:activeFilter')}</Form.Label>
      <StyledItemWrapper>
        {!!orderProcessTypeFilter && (
          <StyledItem><b>{t('withdrawalsTable:orderProcessTypeShortcut')}:</b> {orderProcessTypeFilter.displayName} <CloseButton
            onClick={() => { setOrderProcessTypeFilter(null) }} /></StyledItem>
        )}
        {!!storehouseFilter && (
          <StyledItem><b>{t('goodsReceiptsTable:warehouseShortcut')}:</b> {storehouseFilter.displayName} <CloseButton
            onClick={() => { setStorehouseFilter(null) }} /></StyledItem>
        )}
        {!!officeFilter && (
          <StyledItem><b>{t('orgaUnitShortcut')}:</b> {officeName}<CloseButton onClick={() => { setOfficeFilter(null) }} /></StyledItem>
        )}
        {!!costCenterFilter && (
          <StyledItem><b>{t('costcenterShortcut')}:</b> {costCenterName} <CloseButton
            onClick={() => { setCostCenterFilter(null) }} /></StyledItem>
        )}
        {!!startDate && (
          <StyledItem><b>{t('from')}:</b> {startDate} <CloseButton
            onClick={() => { setStartDateFilter(null) }} /></StyledItem>
        )}
        {!!endDate && (
          <StyledItem><b>{t('to')}:</b> {endDate} <CloseButton
            onClick={() => { setEndDateFilter(null) }} /></StyledItem>
        )}
        {!!pickingProcessFilter.includeNoPositionHasReservations && (
          <StyledItem title={t('withdrawalsTable:includeNoPositionHasReservations')}><PickingIcon1 /> <CloseButton
            onClick={() => {
              setPickingProcessFilter((prev) => ({
                ...prev,
                includeNoPositionHasReservations: false,
              }))
            }} /></StyledItem>
        )}
        {!!pickingProcessFilter.includePartiallyReserved && (
          <StyledItem title={t('withdrawalsTable:includePartiallyReserved')}><PickingIcon2 /> <CloseButton
            onClick={() => {
              setPickingProcessFilter((prev) => ({
                ...prev,
                includePartiallyReserved: false,
              }))
            }} /></StyledItem>
        )}
        {!!pickingProcessFilter.includeReadyForShipment && (
          <StyledItem title={t('withdrawalsTable:includeReadyForShipment')}><PickingIcon3 /> <CloseButton
            onClick={() => {
              setPickingProcessFilter((prev) => ({
                ...prev,
                includeReadyForShipment: false,
              }))
            }} /></StyledItem>
        )}
        {!!pickingProcessFilter.includePickingProcessStarted && (
          <StyledItem title={t('withdrawalsTable:includePickingProcessStarted')}><PickingIcon4 /> <CloseButton
            onClick={() => {
              setPickingProcessFilter((prev) => ({
                ...prev,
                includePickingProcessStarted: false,
              }))
            }} /></StyledItem>
        )}
        {!!pickingProcessFilter.includePartialPicked && (
          <StyledItem title={t('withdrawalsTable:includePartialPicked')}><PickingIcon7 /> <CloseButton
            onClick={() => {
              setPickingProcessFilter((prev) => ({
                ...prev,
                includePartialPicked: false,
              }))
            }} /></StyledItem>
        )}
        {!!pickingProcessFilter.includeHasBeenPicked && (
          <StyledItem title={t('withdrawalsTable:includeHasBeenPicked')}><PickingIcon5 /> <CloseButton
            onClick={() => {
              setPickingProcessFilter((prev) => ({
                ...prev,
                includeHasBeenPicked: false,
              }))
            }} /></StyledItem>
        )}
        {!!pickingProcessFilter.includeIsCompletyShipped && (
          <StyledItem title={t('withdrawalsTable:includeIsCompletyShipped')}><PickingIcon6 /> <CloseButton
            onClick={() => {
              setPickingProcessFilter((prev) => ({
                ...prev,
                includeIsCompletyShipped: false,
              }))
            }} /></StyledItem>
        )}
      </StyledItemWrapper>
    </StyledWrapper>
  )
}

export default ActiveTableFilters
